/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { GEOS } from 'core/utils/constants';

/**
 *
 * `HcpMarketingMain` component is used to display HashiCorp Cloud Platform
 * branding and marketing information. It does not take any arguments.
 * All content is located within the component itself.
 *
 *
 * ```
 * <HcpMarketing::Main />
 * ```
 *
 * @class HcpMarketingMain
 *
 */

const { EU, US } = GEOS;

export default class HcpMarketingMainComponent extends Component {
  @service config;
  @service systemStatus;
  @service intl;

  EU = EU;

  get statusPageUrl() {
    return this.systemStatus.statusPageUrl;
  }

  get hcpStatus() {
    return this.systemStatus.hcp;
  }

  get deployGeo() {
    return this.config.app?.deployGeo ?? US;
  }

  get geoOptions() {
    return [
      {
        text: this.intl.t(
          'components.marketing.landing-page.geo-picker.europe'
        ),
        icon: 'globe',
        value: EU,
      },
      {
        text: this.intl.t(
          'components.marketing.landing-page.geo-picker.global'
        ),
        icon: 'globe',
        value: US,
      },
    ];
  }

  changeGeo = (option) => {
    let configCopy = structuredClone(this.config?.app);
    configCopy.deployGeo = option.value;
    if (this.config) {
      this.config.app = configCopy;
    }
  };
}
